import { Link } from 'react-router';

/**
 * The logo. Its artwork is a CSS mask rather than an image, so the gold follows the theme (bright on the dark
 * mandala, cinnabar on bone) exactly as the rest of the chrome does; `brand/logo-gold.png` keeps the original gold
 * for places a mask cannot reach, like email.
 */
export function Wordmark({ to = '/about', mark = false }: { to?: string; mark?: boolean }) {
  return (
    <Link to={to} className={`wordmark${mark ? ' wordmark--mark' : ''}`} aria-label="Tonist — about">
      <span className="wordmark__art" role="img" aria-hidden="true" />
    </Link>
  );
}
